import React from 'react'
import Signuppage from '../Components/Signup/Signuppage'

const Signup = () => {
  return (
    <Signuppage/>
  )
}

export default Signup